import Section from '@shared/components/Section';
import { SectionProps } from '@shared/types/section';
import { FC } from 'react';

import { COLOR } from '../types/theme';
import { colorToCss } from '../utils/theme';

export const SectionGold: FC<SectionProps> = props => (
  <Section {...props} background={colorToCss(COLOR.Gold2)} />
);

export const SectionDark1: FC<SectionProps> = props => (
  <Section {...props} background={colorToCss(COLOR.Dark1)} />
);

export const SectionDark3: FC<SectionProps> = props => (
  <Section {...props} background={colorToCss(COLOR.Dark3)} />
);
